import React, { useState } from "react";
import { FiDownload, FiPlus } from "react-icons/fi";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MdDownloadForOffline } from "react-icons/md";
import { IoShareSocial } from "react-icons/io5";
import { Button, QRCode, Space, Modal, Tooltip } from "antd";
import { CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import QR from "../../../Assets/Images/qrcode.png";
import user from "../../../Assets/Images/doctordp1.jpeg";

const handleDownload = async () => {
  const pdf = new jsPDF();

  const frontSide = document.querySelector(".card-front");
  const backSide = document.querySelector(".card-back");

  if (frontSide) {
    const frontCanvas = await html2canvas(frontSide);
    const frontImage = frontCanvas.toDataURL("image/png");
    pdf.addImage(frontImage, "PNG", 10, 10, 180, 100);
  }

  pdf.addPage();

  if (backSide) {
    const backCanvas = await html2canvas(backSide);
    const backImage = backCanvas.toDataURL("image/png");
    pdf.addImage(backImage, "PNG", 10, 10, 180, 100);
  }

  pdf.save("Emergency_MedicalCard.pdf");
};

function EmergencyCard() {
  const [text, setText] = useState("https://ant.design/");
  // const [hover, setHover] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [image, setImage] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };

  const data = [
    {
      medicineName: "Paracetamol",
      dosage: "500mg",
      dosageInstructions: "1-1-0-1",
      fromDate: "2024-12-01",
      toDate: "2024-12-10",
    },
    {
      medicineName: "Ibuprofen",
      dosage: "200mg",
      dosageInstructions: "1-1-1",
      fromDate: "2024-12-05",
      toDate: "2024-12-15",
    },
    {
      medicineName: "Amoxicillin",
      dosage: "250mg",
      dosageInstructions: "1-0-1-1",
      fromDate: "2024-12-03",
      toDate: "2024-12-12",
    },
  ];

  return (
    <div className="h-[370px] w-[370px] m-5 border rounded-lg">
      <div className=" h-[13%] bg-[#FFCDD8] flex items-center justify-center rounded p-2">
        <h1 className="font-bold text-normal text-[#3f0d19] mt-3 text-center">
          Emergency Medical Data
        </h1>
      </div>
      <div className="h-[75%] overflow-y-auto scrollwidth bg-white border-t-2 border-t-[#FC1D52]">
        <div className="p-3">
          <div className="flex gap-3">
            <div className="mt-2 w-[65%]">
              <div className="">
                <h3 className="font-medium">Patient Demographics :</h3>
                <div>
                  <h5 className="text-xs font-medium text-gray-500">
                    Name :{" "}
                    <span className="text-xs text-blue-900 font-bold">
                      Balaji
                    </span>
                  </h5>
                  <h5 className="text-xs font-medium text-gray-500">
                    Age :{" "}
                    <span className="text-xs text-blue-900 font-bold">28</span>
                  </h5>
                  <h5 className="text-xs font-medium text-gray-500">
                    DOB :{" "}
                    <span className="text-xs text-blue-900 font-bold">
                      12-06-1996
                    </span>
                  </h5>
                  <h5 className="text-xs font-medium text-gray-500">
                    Address :{" "}
                    <span className="text-xs text-blue-900 font-bold">
                      Peravurani
                    </span>
                  </h5>
                </div>
              </div>
            </div>
            <div className="w-[35%]">
              <div className="w-full flex justify-end">
                <button
                  className="border rounded-lg px-3 text-xs py-1 bg-brand-primaryColor font-semibold text-white hover:bg"
                  onClick={showModal}
                >
                  View EMC
                </button>
              </div>
              <div class="inline-block group mt-1">
                <img
                  src={QR}
                  alt="Sample Image"
                  class="w-32 h-24 rounded-lg shadow-lg shadow-blue-500/30 cursor-pointer transition-all duration-300"
                />
                <div className="flex gap-3 justify-end items-center mt-1">
                  <FiDownload className="w-4 h-4 text-blue-900 font-bold text-base cursor-pointer" />
                  <IoShareSocial className="w-4 h-4 text-blue-900 font-bold text-base cursor-pointer" />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="mt-2">
            <div className="flex gap-2">
              <p className="font-medium text-xs mt-1">Blood Group :</p>
              <p className="font-bold text-blue-900">AB+</p>
            </div>
            <div className="flex gap-2">
              <p className="font-medium text-xs mt-1">Drug Allergy :</p>
              <p className="font-bold text-blue-900">Sulfonamide</p>
            </div>
            <div className="flex gap-2">
              <p className="font-medium text-xs mt-1">Chronic Conditions :</p>
              <div>
                <h6 className="font-semibold text-blue-900">Renal Disease</h6>
                <h6 className="font-semibold text-blue-900"></h6>
              </div>
            </div>
            <div className="flex gap-2">
              <p className="font-medium text-xs mt-1">Insurance :</p>
              <p className="font-semibold text-blue-900">Test1</p>
            </div>
            <div className="">
              <p className="font-medium text-xs mt-1">Current Medications </p>
              <div className="overflow-x-auto scrollwidth">
                <div className="grid grid-cols-1 gap-2">
                  {data.map((row, index) => (
                    <div
                      key={index}
                      className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                    >
                      <div>
                        <div className="flex justify-between">
                          <h3 className="text-sm font-bold text-blue-950">
                            {row.medicineName}
                          </h3>
                          <p className="text-sm font-medium text-blue-950">
                            {row.dosage}
                          </p>
                          <p className="text-sm font-medium text-blue-950">
                            {row.dosageInstructions}
                          </p>
                        </div>
                        <div className="flex justify-between">
                          <div className="flex gap-2 items-center">
                            <h6 className="text-xs text-blue-950 font-medium">
                              From :
                            </h6>
                            <h6 className="border rounded-md text-[10px] p-1">
                              {row.fromDate}
                            </h6>
                          </div>
                          <div className="flex gap-2 items-center">
                            <h6 className="text-xs text-blue-950 font-medium">
                              To :
                            </h6>
                            <h6 className="border rounded-md text-[10px] p-1">
                              {row.toDate}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="border-gray-300" />
      </div>
      <div className="footer h-[44px] bg-[#FFCDD8] rounded"></div>

      <Modal
        title={
          <div className="flex justify-end space-x-4">
            <MdDownloadForOffline
              className="text-blue-600 cursor-pointer font-bold w-6 h-6"
              onClick={handleDownload}
            />
            <CloseOutlined
              className="text-white cursor-pointer"
              onClick={handleCancel}
            />
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={500}
        footer={
          <div>
            {/* <div className="flex justify-end space-x-4 mt-6">
            <button className="px-4 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300" onClick={handleDownload}>
              Download
            </button>
          </div> */}
          </div>
        }
      >
        <div
          className="relative w-full h-[250px] perspective cursor-pointer"
          onClick={handleCardClick}
        >
          <div
            className={`relative w-full h-full transform-style-preserve-3d transition-transform duration-700 ${
              isFlipped ? "rotate-y-180" : ""
            }`}
          >
            <div className="absolute w-full backface-hidden border-2 border-slate-200 rounded-lg bg-white">
              <div className="h-10 bg-blue-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base mt-4 text-white">
                  Emergency Medical Card
                </p>
              </div>
              <div className="w-full p-2 flex justify-evenly">
                <div className="flex gap-5 w-[75%]">
                  <div className="w-24 h-24 bg-white border rounded-xl flex items-center justify-center">
                    <img src={user} alt="" className="w-20 h-20 rounded-xl" />
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Name:{" "}
                      <span className="font-bold text-blue-950">Balaji</span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Age: <span className="font-bold text-blue-950">28</span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      BloodGroup:{" "}
                      <span className="font-bold text-blue-950">AB+</span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Mobile No:{" "}
                      <span className="font-bold text-blue-950">
                        8870558276
                      </span>
                    </h4>
                  </div>
                </div>
                <div className="w-[25%]">
                  <div className="w-24 h-24 rounded-lg flex items-center justify-center bg-white border">
                    <img src={QR} alt="" className="w-20 h-20 rounded-full" />
                  </div>
                </div>
              </div>
              <div className="h-7 bg-red-600 flex items-center justify-center">
                <p className="text-sm font-semibold text-white mt-3">
                  Emergency Contact
                </p>
              </div>
              <div className="flex justify-evenly items-center mt-2">
                <h6 className="text-xs font-medium">
                  Name: <span className="text-sm font-semibold">HariHaran</span>
                </h6>
                <h6 className="text-xs font-medium">
                  Mobile Number:{" "}
                  <span className="text-sm font-semibold">9976685889</span>
                </h6>
              </div>
            </div>
            <div className="absolute w-full h-60 backface-hidden rotate-y-180 border-2 border-slate-200 rounded-md">
              <div className="h-10 bg-blue-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base mt-4 text-white">
                  Emergency Medical Card
                </p>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-center text-center mt-5">
                  <p className="text-sm font-semibold">
                    Access my personal Health Records At:
                    <br />
                    <span className="text-blue-500">
                      www.doxzon.com/PHR-ACCESS
                    </span>
                  </p>
                </div>
                <div className="flex justify-center items-center gap-10">
                  <div>
                    <p className="text-sm font-semibold">
                      MEMBER ID :{" "}
                      <span className="text-sm font-bold text-blue-950">
                        1234567{" "}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default EmergencyCard;
